import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AdvancedSearch } from '@confluence/advanced-search';
import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import { fg } from '@confluence/feature-gating';

export const AdvancedSearchRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		} | null;
		MainLayout: {
			navView: string;
			disableMinWidth: boolean;
		};
	};
} = (): React.JSX.Element => <AdvancedSearch />;

AdvancedSearchRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	} | null;
	MainLayout: {
		navView: string;
		disableMinWidth: boolean;
	};
} => {
	return {
		Screen: fg('unified_search_in_confluence')
			? null
			: { screenEvent: { name: 'advancedSearchScreen' } },
		MainLayout: {
			navView: PRODUCT_HOME_ID,
			disableMinWidth:
				UNSAFE_expValEqualsNoExposure(
					'fullpage_search_summarize_button_revamp',
					'fullpage_search_summarize_button_revamp_treatment',
					'visibility',
				) ||
				UNSAFE_expValEqualsNoExposure(
					'fullpage_search_summarize_button_revamp',
					'fullpage_search_summarize_button_revamp_treatment',
					'border',
				),
		},
	};
};
